import AssessmentPagesFooter from "@/components/AssessmentPagesFooter";
import AssessmentSideBar from "@/components/AssessmentSideBar";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const InstructionPage: React.FC = () => {
	const navigate = useNavigate();
	const [isChecked, setIsChecked] = useState(false);
	const dos = [
		"Test equipment in advance: Ensure stable internet, functional webcam/microphone, and compatible device.",
		"Prepare your environment: Choose a quiet, well-lit space free from distractions or other people.",
		"Review exam rules: Understand permitted materials, time limits, and platform navigation before starting.",
		"Stay visible and focused: Keep your face clearly visible to the webcam and avoid looking off-screen.",
		"Contact support if needed: Report technical issues immediately via approved channels.",
	];

	const donts = [
		"Use prohibited items: Avoid phones, notes, calculators, headphones, or any unauthorized devices.",
		"Communicate or leave: No talking, interacting with others, or exiting the webcam’s view during the exam.",
		"Engage in suspicious behavior: Avoid covering your face, reading questions aloud, or frequent eye movements away from the screen.",
		"Bypass proctoring systems: Do not attempt to disable monitoring software or access restricted tools.",
		"Violate time limits: Complete the exam within the allocated timeframe without unauthorized breaks.",
	];
	return (
		<>
			<div className="min-h-[90vh]">
				<AssessmentSideBar />
				<div className=" mx-auto   max-w-6xl pb-5 ">
					<h1 className="text-3xl font-semibold text-center   mt-4 mb-5">
						Assessment Instructions
					</h1>

					<div className="bg-white border rounded-xl 	p-6 w-full">
						<h2 className="text-2xl font-semibold  mb-3">Dos</h2>
						<ul className=" space-y-6 text-gray-700">

							{dos.map((item, index) => (
								<li key={index} className="flex items-center gap-3">
									<span><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 5.917L5.724 10.5L15 1.5" stroke="#9AB9B1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
									</span>
									{item} </li>
							))}
						</ul>
						<h2 className="text-2xl font-semibold  mt-4 mb-3 ">DON’Ts</h2>
						<ul className="list-decimal list-inside space-y-6 text-gray-700">
							{donts.map((item, index) => (
								<li key={index} className="flex items-center gap-3">
									<span><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M5.65686 16.9706L16.9706 5.65687" stroke="#DE6F6F" strokeWidth="1.5" strokeLinecap="round" />
										<path d="M16.9706 16.9706L5.65687 5.65687" stroke="#DE6F6F" strokeWidth="1.5" strokeLinecap="round" />
									</svg>

									</span>
									{item} </li>
							))}
						</ul>
					</div>

					<div className="mt-6 flex items-center">
						<input
							type="checkbox"
							id="readInstructions"
							checked={isChecked}
							onChange={(e) => setIsChecked(e.target.checked)}
							className="size-5"
						/>
						<label
							htmlFor="readInstructions"
							className="ml-3 text-gray-700 text-sm sm:text-base"
						>
							I have read all the instructions.
						</label>
					</div>
					<div className="flex justify-center">
						<button
							onClick={() => {
								sessionStorage.setItem("assessmentSection", "behavioural");
								navigate("/highlights");
							}}
							className={`mt-6  w-full sm:w-auto bg-black text-white font-medium py-2 px-6 rounded-lg shadow-md transition-opacity duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${isChecked ? "" : "opacity-50 cursor-not-allowed"
								}`}
							disabled={!isChecked}
						>
							Proceed
						</button>
					</div>
				</div>
			</div>
			<AssessmentPagesFooter />
		</>
	);
};

export default InstructionPage;
